import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7c4315d7"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonNumberAnimate: require('/builds/wj/fe/wenjuan-homesite/components/common/number-animate.vue').default,CommonStretchBanner: require('/builds/wj/fe/wenjuan-homesite/components/common/stretch-banner.vue').default,CommonScrollCard: require('/builds/wj/fe/wenjuan-homesite/components/common/scroll-card.vue').default})
